<!--<div class="event-status {{statusClass}}">
    <ng-container *ngIf="icon">
        <fa-icon [icon]="icon" [fixedWidth]="true"></fa-icon> {{text}}
    </ng-container>
</div>-->
<span class="{{ statusClass }}" [ngClass]="{ 'badge rounded-pill': statusClass }">
  @if (showDate && meetDates) {
    <app-event-date [meetDates]="meetDates" [date]="date" [heatDates]="heatDates"></app-event-date>
  } @else {
    {{ text }}
  }
</span>
